<template>
    <v-container>
        <v-divider></v-divider>
        <v-row >
            <v-col class="mx-10" cols="2">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date"
                            label="เดือนที่แสดงข้อมูล"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        @change="reload()"
                        type="month"
                        no-title
                        :show-current="false"
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col>
                <!--<v-select
                    small-chips
                    chips
                    placeholder="เลือกกลุ่มของสมาชิก"
                    label="กลุ่ม"
                    multiple
                    :items="groups">
                </v-select>-->
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="mx-10" cols="2">
                <v-btn tile style="color:white" color="green" @click="csvExport()">
                    <v-icon left>mdi-table-arrow-down</v-icon>Export CSV
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="mx-10">
                <v-data-table
                :headers="headers"
                :items="desserts"
                :items-per-page="100"
                class="elevation-1"
            >
                <!--<template v-slot:footer>
                    <v-divider></v-divider>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col>
                            สมาชิกที่เปลี่ยนแปลงประจำเดือน {{date}}  <b> : 178 คน</b>
                        </v-col>
                    </v-row>
                </template>-->
            </v-data-table>
            </v-col>
            
        </v-row>
          
    </v-container>
  
</template>


<script>
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

import Constant from '@/model/utils/Constants.js'
export default {
    props: ["station_code"],
    name: "ReportMember",
    data: () => ({
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        groups: Constant.groups,
        headers: [
                {text: 'วันที่', value: 'date',width:"15%"},
                {text: 'จำนวนสมาชิกใหม่วันนี้', value: 'col1'},
                {text: 'จำนวนสมาชิกใหม่เดือนนี้', value: 'col2'},
                {text: 'จำนวนสมาชิกทั้งหมด', value: 'col3'},
                {text: 'จำนวนสมาชิกที่ใช้งานวันนี้', value: 'col4'},
                {text: 'จำนวนสมาชิกที่ใช้งานเดือนนี้', value: 'col5'},
            ],
        desserts: [],
        report_duedate : null
    }),
    mounted : function () {
        var que = this.$store.commit('addLoading')
        axios.post(
            config.api.url.manage.customer.customerbystationcode ,
            {station_code:this.station_code},
            { headers: Staff.getTokenHeader()}
        ).then(rs => {
            this.$store.commit('finishLoading',que)
            this.report_duedate = rs.data.report_duedate
            this.reload()
        });
    },
    methods: {
        reload(){
            var que = this.$store.commit('addLoading')

            var start_date = this.date.substring(0,4) + '-' + this.date.substring(5,7) + '-01'
            var d = new Date(start_date)
            d.setHours(d.getHours()+7)
            d.setMonth(d.getMonth()+1)
            d.setDate(d.getDate()-1)
            var end_date = d.toISOString().substring(0,10)

            if(this.report_duedate && this.report_duedate != null && this.report_duedate > 0){
                var duedate = '00' + this.report_duedate
                duedate = duedate.substring(duedate.length-2,duedate.length)
                end_date = this.date.substring(0,4) + '-' + this.date.substring(5,7) + '-' + duedate
                var d2 = new Date(end_date)
                d2.setHours(d2.getHours()+7)
                d2.setMonth(d2.getMonth()-1)
                d2.setDate(d2.getDate()+1)
                start_date = d2.toISOString().substring(0,10)
            }

            axios
            .post(config.api.url.manage.dashboard.get_memberstat,{
                station_code : this.station_code
                ,start_date : start_date
                ,end_date : end_date
            },{ headers: Staff.getTokenHeader()}
            ).then(response => {
                this.desserts = []
                response.data.forEach(r => {
                    var d = new Date(r.date)
                    d.setHours(d.getHours()+7)
                    this.desserts.push(
                        {
                            'date': d.toISOString().substring(0,10),
                            'col1': r.new_today, 
                            'col2': r.new_month, 
                            'col3': r.allcount, 
                            'col4': r.used_today, 
                            'col5': r.used_month
                        }
                    )
                });
                this.$store.commit('finishLoading',que)
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        csvExport() {
            let csvContent = "data:text/csv;charset=utf-8," + "\ufeff";
            csvContent += [
                this.headers.map(h=>h.text).join(","),
                ...this.desserts.map(item => Object.values(item).join(","))
            ].join("\n");
            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", "report_member_" + this.date.substring(0,4) + '-' + this.date.substring(5,7) + ".csv");
            link.click();
        }
    }
}
</script>